export default __webpack_public_path__ + "media/zurb/img/home/jacks-523436cbff47f937e815f335f7bf9f66.png";